import React from 'react';
import { DocumentAddIcon, MinusIcon, ViewIcon } from 'styles/components/Icons';
import { VehicleTruckProfile } from 'styled-icons/fluentui-system-filled';
import Stepper, { Step } from 'mrf/view/Stepper';

export default function TransferStepper({ transferStatus }) {

  let step, result

  if(transferStatus === `Created`){
      step = 1
  }else if(transferStatus === 'Waiting For Licenses'){
      step = 2
  }else if(transferStatus === `License Active For Shipment` || transferStatus === `Rejected`){
      step = 3
  }

  if(transferStatus === 'Rejected'){
      result = 
      <Stepper step={step}>
          <Step icon={DocumentAddIcon} label='Created' />
          <Step icon={ViewIcon}        label="Waiting For Licenses" />
          <Step icon={MinusIcon}       label="Rejected" />
      </Stepper>
  }else{
      result =
      <Stepper step={step} labelSize="10px">
        <Step icon={DocumentAddIcon}     label="Created" />
        <Step icon={ViewIcon}            label="Waiting For Licenses" />
        <Step icon={VehicleTruckProfile} label="License Active For Shipment" />
      </Stepper>
  };

  return result;
}